import { Link } from 'react-router-dom';
import { ArrowRightStartOnRectangleIcon, ArrowUturnLeftIcon } from '@heroicons/react/24/outline';
import {
  MASTHEAD_ICON_BUTTON,
  MASTHEAD_EXIT_TAB,
  MASTHEAD_FULL_INLINE,
  MASTHEAD_PHONE_BLOCK,
} from '../table-session/mastheadChrome';
import type { SessionSummaryLocationState } from '../../pages/SessionSummaryPage';

/**
 * The practice run's way off the hand: back to the module list, or out of the session entirely.
 *
 * Phone: both links collapse to icon buttons with aria-label/title — the same workaround
 * the pre-023 /problems phone layout used for End Session (an exit icon, not text).
 */
export function PracticeMastheadLinks({
  backTo,
  leaveTo,
  leaveState,
}: {
  backTo: string;
  leaveTo: string;
  /** The visit's numbers, handed to the summary page. Absent when there is nothing to summarise. */
  leaveState?: SessionSummaryLocationState;
}) {
  return (
    <>
      <Link
        to={backTo}
        aria-label="Back to modules"
        title="Back to modules"
        // `md:p-0` turns the icon button back into a plain text link from md up, which left it the
        // height of its own line box — 20px, under the 24 × 24 hard floor (FR-021a / WCAG 2.5.8)
        // at both tablet and desktop widths. The minimum is stated on the md: form only; the
        // masthead is far taller than 24px there, so nothing else in the strip moves. The unfolded
        // Fold held sideways at 749 wide (`fold-ls`) shows the same text link below md, so it
        // takes the same minimum (it measured 20.3px there, 2026-10-01).
        className={
          MASTHEAD_ICON_BUTTON +
          ' text-cream no-underline md:p-0 md:hover:bg-transparent md:hover:underline fold-ls:p-0 narrow:p-1' +
          ' md:inline-flex md:items-center md:min-h-[24px]' +
          ' fold-ls:inline-flex fold-ls:items-center fold-ls:min-h-[24px]'
        }
      >
        <span className={MASTHEAD_FULL_INLINE}>← Back to modules</span>
        <ArrowUturnLeftIcon className={`h-5 w-5 ${MASTHEAD_PHONE_BLOCK}`} aria-hidden="true" />
      </Link>
      <Link
        to={leaveTo}
        state={leaveState}
        aria-label="Leave the Table"
        title="Leave the Table"
        className={MASTHEAD_EXIT_TAB}
      >
        <span className={MASTHEAD_FULL_INLINE}>Leave the Table</span>
        <ArrowRightStartOnRectangleIcon className={`h-5 w-5 ${MASTHEAD_PHONE_BLOCK}`} aria-hidden="true" />
      </Link>
    </>
  );
}
